/**
 * Utility to resolve image URL - prepend backend if it's a relative path.
 */
export const resolveMedia = (src) => {
  if (!src) return "";
  if (src.startsWith("http://") || src.startsWith("https://") || src.startsWith("data:") || src.startsWith("blob:")) {
    return src;
  }
  const backend = process.env.REACT_APP_BACKEND_URL || "";
  return `${backend}${src}`;
};
